import {
  CREATE_TICKETS_USER_FAILURE,
  CREATE_TICKETS_USER_SUCCESS,
  CREATE_TICKETS_USER_REQUEST,

  DELETE_TICKETS_USER_FAILURE,
  DELETE_TICKETS_USER_SUCCESS,
  DELETE_TICKETS_USER_REQUEST,
} from '../actions/types';
import ResponseService from '../../utils/ResponseService';
import ApplicationError from '../../utils/ApplicationError';

const initialState = {
  ticket: undefined,
  error: ApplicationError.buildDefault(),
  isFetching: false,
  ...ResponseService.defaultPaginationMetaData()
};

const ticketsUsersReducer = (state = initialState, action ) => {
  switch(action.type) {
    case  CREATE_TICKETS_USER_REQUEST:
      return {...state, isFetching: true }
    case  CREATE_TICKETS_USER_SUCCESS:
      return {...state, isFetching: false, ticket: action.payload, error: ApplicationError.buildDefault() }
    case  CREATE_TICKETS_USER_FAILURE:
      return {...state, isFetching: false, error: action.payload }

    case  DELETE_TICKETS_USER_REQUEST:
      return {...state, isFetching: true }
    case  DELETE_TICKETS_USER_SUCCESS:
      return {...state, isFetching: false, error: ApplicationError.buildDefault() }
    case  DELETE_TICKETS_USER_FAILURE:
      return {...state, isFetching: false, error: action.payload }
    default: 
      return state
  }
}

export default ticketsUsersReducer;